import React from 'react';
import propTypes from './propTypes';

const AboutStops = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M8 8H16V16H8V8Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.41 7.59 20 12 20C16.41 20 20 16.41 20 12C20 7.59 16.41 4 12 4C7.59 4 4 7.59 4 12Z" fill="currentColor" />
  </svg>
);

AboutStops.propTypes = propTypes;

export default AboutStops;
